import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '@modules/error-dialog/components/error-dialog/error-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class InvalidInputExceptionInterceptor implements HttpInterceptor {
  static isInvalidInputException(err: any) {
    return !!err?.error?.error && !!err?.error?.message;
  }

  constructor(private dialog: MatDialog) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 400) {
            if (!!err?.error?.error && !!err?.error?.message) {
              this.dialog.open(ErrorDialogComponent, {
                data: {
                  title: err.error.error,
                  message: err.error.message,
                }
              });
            }

            throw err;
          } else {
            throw err;
          }
        } else {
          throw err;
        }
      }),
    );
  }
}
